import * as LDClient from 'launchdarkly-js-client-sdk';
import getVisitorId from '../storage/getVisitorId';

const flags = {
  'HOVER_MENU_NAVIGATION_BAR': 'DISCO-196-hover-menu-mex-components',
  'SIGN_IN_VISIBILITY': 'mex-14062-sign-in-visibility',
  'NAV_LINK_TO_QUOTES': 'ECOMM-30-nav-link-to-quotes-page'
};

let client;

export function setClient(newClient) {
  client = newClient;
}

const isFeatureEnabled = async (key) => {
  try {
    if (!client) {
      let context;
      let appName = window?.components.action_tracker?.application_id || 'mex-components';
      const visitorId = getVisitorId();

      const visitorContext = {
        kind: 'user',
        appName: appName,
        key: visitorId,
      };

      const fallbackContext = {
        kind: 'user',
        appName: appName,
        anonymous: true,
      };

      visitorId ? context = visitorContext : context = fallbackContext;
      
      client = LDClient.initialize(
        window.components.launchdarkly_client_key,
        context,
        {
          bootstrap: 'localStorage',
          sendEventsOnlyForVariation: true,
        }
      );
      setClient(client);
    }
    await client?.waitForInitialization(5);
    return client.variation(key, false);
  } catch (err) {
    console.log('Error checking feature flag:', err.message);
    return false;
  }
};

export const isHoverMenuEnabled = async () => {
  return isFeatureEnabled(flags.HOVER_MENU_NAVIGATION_BAR);
};

export const isSignInVisible = async () => {
  return isFeatureEnabled(flags.SIGN_IN_VISIBILITY);
};
